import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { CSR_INITIATIVES, BOOKING_URL } from "@/data/site";

export default function CSR() {
  return (
    <div data-testid="csr-page">
      <section className="pt-16 pb-20 md:pt-24 md:pb-28 border-b border-[#E5E5E5]">
        <div className="container-cc grid grid-cols-1 lg:grid-cols-12 gap-12 items-end">
          <div className="lg:col-span-7">
            <div className="overline mb-8"><span className="kicker-line" />CSR & Volunteering</div>
            <h1 className="font-serif-display text-5xl md:text-7xl leading-[1.02]">
              Purpose, made <span className="italic text-[#A60201]">participative.</span>
            </h1>
            <p className="mt-8 text-lg text-[#525252] max-w-xl leading-relaxed">
              We design and operate corporate volunteering and CSR programs that employees actually show up for — because they connect personal purpose to organizational impact.
            </p>
          </div>
          <div className="lg:col-span-5">
            <div className="aspect-[4/3] overflow-hidden">
              <img src="https://images.pexels.com/photos/6646918/pexels-photo-6646918.jpeg" alt="Volunteers serving communities" className="w-full h-full object-cover" />
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="overline mb-6"><span className="kicker-line" />What we run</div>
          <h2 className="font-serif-display text-4xl md:text-5xl leading-tight max-w-3xl mb-14">Six pillars of purpose-led employee engagement.</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#E5E5E5] border border-[#E5E5E5]">
            {CSR_INITIATIVES.map((c, i) => (
              <div key={i} data-testid={`csr-${i}`} className="bg-white p-8 hover:bg-[#FFE8D9] transition-colors">
                <div className="font-serif-display text-2xl">{c.title}</div>
                <div className="mt-3 text-sm text-[#525252] leading-relaxed">{c.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section bg-[#0A0A0A] text-white">
        <div className="container-cc grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="overline text-white/60 mb-6"><span className="kicker-line" />Why this matters</div>
            <h2 className="font-serif-display text-4xl md:text-5xl leading-tight">Volunteering is the most under-leveraged engagement asset in HR.</h2>
            <p className="mt-6 text-white/70 text-lg max-w-xl leading-relaxed">When designed right, corporate volunteering outperforms most engagement interventions on connection, belonging and organizational pride. We help you operationalize that.</p>
          </div>
          <div className="lg:col-span-5">
            <div className="grid grid-cols-2 gap-px bg-white/10 border border-white/10">
              <div className="bg-[#0A0A0A] p-7"><div className="font-serif-display text-4xl text-[#FEBE98]">60+</div><div className="text-sm text-white/70 mt-2">NGO Partners</div></div>
              <div className="bg-[#0A0A0A] p-7"><div className="font-serif-display text-4xl text-[#FEBE98]">200K+</div><div className="text-sm text-white/70 mt-2">Volunteering Hours</div></div>
              <div className="bg-[#0A0A0A] p-7"><div className="font-serif-display text-4xl text-[#FEBE98]">35</div><div className="text-sm text-white/70 mt-2">Cities of Impact</div></div>
              <div className="bg-[#0A0A0A] p-7"><div className="font-serif-display text-4xl text-[#FEBE98]">+38%</div><div className="text-sm text-white/70 mt-2">Engagement Uplift</div></div>
            </div>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-cc">
          <div className="bg-[#FEBE98] p-10 md:p-16">
            <h2 className="font-serif-display text-4xl md:text-5xl leading-tight max-w-3xl">Design a CSR program your employees will remember.</h2>
            <div className="mt-8 flex flex-wrap gap-4">
              <a href={BOOKING_URL} target="_blank" rel="noreferrer" className="btn-primary" data-testid="csr-book-call">Book Discovery Call <ArrowUpRight size={16} /></a>
              <Link to="/contact" className="btn-secondary" data-testid="csr-contact">Talk to our CSR lead</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
